import React from "react";
import { motion } from "framer-motion";
import { ExternalLink, Github } from "lucide-react";

const ProjectCard = ({ title, description, image, technologies, liveLink, githubLink }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-gray-800 rounded-xl overflow-hidden shadow-xl"
    >
      <div className="relative group">
        <img
          src={image}
          alt={title}
          className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center space-x-4">
          <a
            href={liveLink}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 bg-blue-500 rounded-full hover:bg-blue-600 transition-colors"
          >
            <ExternalLink className="w-6 h-6 text-white" />
          </a>
          <a
            href={githubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors"
          >
            <Github className="w-6 h-6 text-white" />
          </a>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        <p className="text-gray-400 mb-4">{description}</p>
        <div className="flex flex-wrap gap-2">
          {technologies.map((tech) => (
            <span key={tech} className="px-3 py-1 bg-gray-700 text-sm text-gray-300 rounded-full">
              {tech}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

const Projects = ({ limit }) => {
  const projects = [
    {
      title: "E-Commerce Platform",
      description: "A full-stack e-commerce platform with real-time inventory management",
      image: "https://res.cloudinary.com/dqovjmmlx/image/upload/v1740392128/banner23_cfuhuk.jpg",
      technologies: ["React", "Node.js", "MongoDB", "Express"],
      liveLink: "https://shopfinity-mern.vercel.app",
      githubLink: "https://devplus.fun/projects"
    },
    {
      title: "Social Media ",
      description: "A Social Media App for Anonymous Sharing",
      image: "https://res.cloudinary.com/dydnhyxfh/image/upload/v1739213254/anonymous-posts/srzmnmbktm5dm4lcsxhh.webp",
      technologies: ["React","Tailwind", "MongoDB", "Node.js"],
      liveLink: "https://anonypost-app.vercel.app",
      githubLink: "https://github.com/mahmud-r-farhan/AnonyPost"
    },
    {
      title: "Customer Service Center",
      description: "Customer Service Center Application is a web-based system.",
      image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/o35bt4gp4v4f5m7a1jor.jpg",
      technologies: ["React", "Framer Motion", "WebSocket", "Node.js"],
      liveLink: "https://customer-service-center.vercel.app",
      githubLink: "https://github.com/mahmud-r-farhan/Customer-Service-Center"
    }
  ];

  const displayedProjects = limit ? projects.slice(0, limit) : projects;

  return (
    <section id="projects" className="mt-16 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-white mb-4">
            {limit ? "Featured Projects" : "All Projects"}
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {limit 
              ? "Here are some of my recent projects that showcase my skills and experience"
              : "Explore my complete portfolio of projects"
            }
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayedProjects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
